import { useQuery } from '@tanstack/react-query';

import { HintCoverageAccountType, getPropertyHintCoverage } from '~/services/ConnectionGoogleService';

export const propertyHintCoverageQueryKeys = {
  all: ['propertyHintCoverage'] as const,
  detail: (propertyId: string, accountType: HintCoverageAccountType) =>
    [...propertyHintCoverageQueryKeys.all, propertyId, accountType] as const,
};

export function useGetPropertyHintCoverage(propertyId: string | null, accountType: HintCoverageAccountType) {
  return useQuery({
    queryKey: propertyHintCoverageQueryKeys.detail(propertyId ?? '', accountType),
    queryFn: async ({ signal }) => {
      return getPropertyHintCoverage(propertyId, { accountType }, { signal });
    },
    enabled: !!propertyId,
  });
}
